module.exports = __webpack_public_path__ + "img/index-img-04.0ae9be3b.png";